import { render, staticRenderFns } from "./InvitationResult.vue?vue&type=template&id=a8fe0ccc&"
import script from "./InvitationResult.vue?vue&type=script&lang=js&"
export * from "./InvitationResult.vue?vue&type=script&lang=js&"
import style0 from "./InvitationResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports